module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sky-lightbox', {
      open: _vm.open
    }]
  }, [_c('button', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "arrow"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "previous",
    on: {
      "click": _vm.previous
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "arrow"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "cross"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.type === 'images' || !_vm.type) ? _c('ul', {
    staticClass: "media"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: {
        active: index === _vm.activeIndex
      }
    }, [_c('sky-crop', {
      attrs: {
        "src": item.src,
        "mode": "contain"
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.type === 'videos') ? _c('ul', {
    staticClass: "media"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: {
        active: index === _vm.activeIndex
      }
    }, [_c('cookie-blocker', [_c('sky-video', {
      attrs: {
        "poster": item.poster,
        "src": item.src
      }
    })], 1)], 1)
  })) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "navigation"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: {
        active: index === _vm.activeIndex
      },
      on: {
        "click": function($event) {
          _vm.setActive(index)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-809f6db0"}!./scripts/sky-lightbox/sky-lightbox.html
// module id = 379
// module chunks = 1